<template>
  <div class="modify-schedule-page"  data-test="multi-modify-schedule">
    <div class="main">
      <choosed-nav :len="obj.courseArrangeIds.length" /> 
      <div class="item-tips flex-between">
        <span>上课日期不变，时段修改为</span>
        <div class="always-tag" @click.stop="chooseCommonTimePeriods">常用时段</div>
      </div>
      <van-cell title="开始时间" is-link :value="obj.startTime" @click="choiceStartTime"/>
      <van-cell title="结束时间" :border="false" is-link :value="obj.endTime" @click="choiceEndTime" />
      <!-- <div class="item-tips">是否通知学员</div>
      <van-cell title="消息提醒">
        <template>
          <van-switch v-model="obj.messageNotify" size="24px"/>
        </template>
      </van-cell>
      <van-cell title="短信提醒" :border="false">
        <template>
          <van-switch v-model="obj.smsNotify" size="24px"/>
        </template>
      </van-cell> -->
    </div>
    <div class="footer">
      <van-button 
        square round 
        block 
        type="primary" 
        data-test="multi-modify-schedule-btn-save"
        @click="submitConfirm">
          保存
        </van-button>
    </div>
    <van-calendar v-model="showOpenDatePicker" 
      :default-date="new Date(obj.courseDate)"
      @confirm="openDatePickerConfirm" 
      :show-confirm="false" :min-date="new Date(2020, 0, 1)"/>
  </div>
</template>

<script>
import choosedNav from './choosed-nav.vue';

export default {
  name: "multiModifySchedule",
  components:{
    choosedNav,
  },
  data() {
    return {
      pageTitle: "修改上课时段",
      obj: {
        courseArrangeIds: [],
        startTime: '',
        endTime: '',
        messageNotify: false,
        smsNotify: false,
        checkConflict: true,
        checkConflictScope: 3,
      },
      showOpenDatePicker: false,
    }
  },
  methods: {
    openDatePickerConfirm(val) {
      this.obj.courseDate = app.tool.date.formatDatetime(val, "yyyy-MM-dd");
      this.showOpenDatePicker = false;
    },
    async chooseCommonTimePeriods() {
      const res = await app.x3.side.xsTimePeriods({
        config:{
          radio: true
        }
      });
      Object.assign(this.obj, res);
    },
    choiceStartTime() {
      app.x3.picker.datetime({
        type:"time",
        value: this.obj.startTime,
      }).then(res=>{
        this.obj.startTime = res;
      })
    },
    choiceEndTime() {
      app.x3.picker.datetime({
        type:"time",
        value: this.obj.endTime,
      }).then(res=>{
        this.obj.endTime = res;
      })
    },
    timeGetTime(str) {
      return Number(str.substr(0, 2) + str.substr(3, 2));
    },
    submitConfirm () {
      if (this.timeGetTime(this.obj.startTime) >= this.timeGetTime(this.obj.endTime)) {
        this.$toast.fail( '开始时间不能大于结束时间' );
        return;
      }
      vant.Dialog.confirm({message: '确定保存？', confirmButtonText: '确定'})
        .then(()=>{
          this.submit();
        })
        .catch(err=> {
          console.log('取消了。。')
        })

    }, 
    submit() {

      this.showLoading();
      this.$api.batchModifyCourseTime(this.obj).then(res=>{
        if (res.code === 200) {
          app.vue.$emit("refresh-multi-edit-page");
          this.$toast.success( "修改成功");
          setTimeout(()=>{
            this.$router.back();
          }, 300)
        } else if (res.code == 830000005) {
          // 临时变量，用于存储排课冲突信息，以便在冲突页面展示
          this.$toast.clear();
          app.ls.set('multi-edit-course-error', res.data)
          this.$router.push("/multiPaikeErr")
        }
      })
    },
    continueModify () {
      let errs = app.ls.get("multi-edit-course-error");      
      // 冲突类型1表示选择的排课内校验冲突
      // 用户选择忽略，需要继续校验成系统其它排课有无冲突
      this.obj.checkConflict = errs.conflictType === 1 ? true : false;
      errs.conflictType === 1 && (this.obj.checkConflictScope = 2); 
      this.submit();      
      this.obj.checkConflict = true;
      this.obj.checkConflictScope === 3;
    }
  },
  created() {
    Object.assign(this.obj, app.ls.get("multi-modify-schedule-obj"));
    this.$onBus("multi-edit-course-continue", this.continueModify);
  },
  beforeDestroy() {
    app.ls.remove('modify-schedule-obj');
  },
};
</script>

<style lang="scss" scoped>
.modify-schedule-page {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
    .item-tips {
      height: calc(var(--w) * 44);
      line-height: calc(var(--w) * 44);
      padding: 0 calc(var(--gap) * 16);
      color: var(--g6);      
    }
    .always-tag {
      color: var(--c1);
    }
  }
  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: calc(var(--w) * 40);
    }
  }
}
</style>